export default __webpack_public_path__ + "253fba0ba39dc3ce46b951810c116556.png";